var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showForm
      ? _c("div", [
          _vm._m(0),
          _c("div", { staticClass: "member custom-container-xl" }, [
            _c("div", { staticClass: "member__box" }, [
              _c("div", { staticClass: "personal__info" }, [
                _c("div", { staticClass: "personal__item" }, [
                  _c("span", { staticClass: "item__title" }, [
                    _vm._v("出生日期")
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "item__input",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.dateModal = true
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.birthDate))]),
                      _c(
                        "v-dialog",
                        {
                          ref: "dialogDate",
                          attrs: {
                            "return-value": _vm.birthDate,
                            width: "290px",
                            persistent: ""
                          },
                          on: {
                            "update:returnValue": function($event) {
                              _vm.birthDate = $event
                            },
                            "update:return-value": function($event) {
                              _vm.birthDate = $event
                            }
                          },
                          model: {
                            value: _vm.dateModal,
                            callback: function($$v) {
                              _vm.dateModal = $$v
                            },
                            expression: "dateModal"
                          }
                        },
                        [
                          _c(
                            "v-date-picker",
                            {
                              staticClass: "picker date-picker",
                              attrs: {
                                "first-day-of-week": 0,
                                locale: "zh-cn",
                                scrollable: "",
                                "header-color": "rgba(217, 217, 217, 0.25)",
                                color: "primary",
                                max: "2099-12-31",
                                min: "0676-01-01"
                              },
                              model: {
                                value: _vm.birthDate,
                                callback: function($$v) {
                                  _vm.birthDate = $$v
                                },
                                expression: "birthDate"
                              }
                            },
                            [
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: { text: "", color: "error" },
                                  on: {
                                    click: function($event) {
                                      _vm.dateModal = false
                                    }
                                  }
                                },
                                [_vm._v("取消")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { text: "", color: "error" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.dialogDate.save(
                                        _vm.birthDate
                                      )
                                    }
                                  }
                                },
                                [_vm._v("確認")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "personal__item" }, [
                  _c("span", { staticClass: "item__title" }, [
                    _vm._v("出生時間")
                  ]),
                  _c("div", { staticClass: "time-wrap" }, [
                    _c(
                      "div",
                      {
                        staticClass: "item__input",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.timeModal = true
                          }
                        }
                      },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.birthTime))]),
                        _c(
                          "v-dialog",
                          {
                            ref: "dialogTime",
                            attrs: {
                              "return-value": _vm.birthTime,
                              width: "290px",
                              persistent: ""
                            },
                            on: {
                              "update:returnValue": function($event) {
                                _vm.birthTime = $event
                              },
                              "update:return-value": function($event) {
                                _vm.birthTime = $event
                              }
                            },
                            model: {
                              value: _vm.timeModal,
                              callback: function($$v) {
                                _vm.timeModal = $$v
                              },
                              expression: "timeModal"
                            }
                          },
                          [
                            _vm.timeModal
                              ? _c(
                                  "v-time-picker",
                                  {
                                    staticClass: "picker time-picker",
                                    attrs: {
                                      scrollable: "",
                                      "ampm-in-title": "",
                                      "header-color":
                                        "rgba(217, 217, 217, 0.25)",
                                      color: "primary"
                                    },
                                    model: {
                                      value: _vm.birthTime,
                                      callback: function($$v) {
                                        _vm.birthTime = $$v
                                      },
                                      expression: "birthTime"
                                    }
                                  },
                                  [
                                    _c("v-spacer"),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { text: "", color: "error" },
                                        on: {
                                          click: function($event) {
                                            _vm.timeModal = false
                                          }
                                        }
                                      },
                                      [_vm._v("取消")]
                                    ),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { text: "", color: "error" },
                                        on: {
                                          click: function($event) {
                                            return _vm.$refs.dialogTime.save(
                                              _vm.birthTime
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("確認")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("label", { staticClass: "checkbox-wrap" }, [
                      _vm._v("\n                我不知道\n                "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.IDontKnow,
                            expression: "IDontKnow"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.IDontKnow)
                            ? _vm._i(_vm.IDontKnow, null) > -1
                            : _vm.IDontKnow
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.IDontKnow,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.IDontKnow = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.IDontKnow = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.IDontKnow = $$c
                            }
                          }
                        }
                      }),
                      _c("span", { staticClass: "checkmark" })
                    ])
                  ])
                ]),
                _c("div", { staticClass: "personal__item" }, [
                  _vm._m(1),
                  _c("div", { staticClass: "item__sex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "sex-box male",
                        class: { activeSex: _vm.IsDaylight },
                        on: {
                          click: function($event) {
                            _vm.IsDaylight = true
                          }
                        }
                      },
                      [_vm._v("是")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "sex-box female",
                        class: { activeSex: !_vm.IsDaylight },
                        on: {
                          click: function($event) {
                            _vm.IsDaylight = false
                          }
                        }
                      },
                      [_vm._v("否")]
                    )
                  ])
                ]),
                _c("div", { staticClass: "personal__item" }, [
                  _c("span", { staticClass: "item__title" }, [
                    _vm._v("出生地點")
                  ]),
                  _c(
                    "div",
                    { staticClass: "item__input" },
                    [
                      _c("v-autocomplete", {
                        staticClass: "select",
                        attrs: {
                          items: _vm.cityList,
                          label: "請選擇或輸入出生地點",
                          "background-color": "transparent",
                          solo: "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.birthCity,
                          callback: function($$v) {
                            _vm.birthCity = $$v
                          },
                          expression: "birthCity"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "personal__item" }, [
                  _c("span", { staticClass: "item__title" }, [
                    _vm._v("欲前往的城市")
                  ]),
                  _c(
                    "div",
                    { staticClass: "item__input" },
                    [
                      _c("v-autocomplete", {
                        staticClass: "select",
                        attrs: {
                          items: _vm.cityList,
                          label: "請選擇或輸入目標城市",
                          "background-color": "transparent",
                          solo: "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.destinationCity,
                          callback: function($$v) {
                            _vm.destinationCity = $$v
                          },
                          expression: "destinationCity"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _c("div", { staticClass: "personal__btns" }, [
                _c(
                  "div",
                  {
                    staticClass: "personal__save",
                    class: { notReady: !_vm.formReady },
                    on: { click: _vm.calculate }
                  },
                  [_vm._v("計算")]
                )
              ])
            ])
          ])
        ])
      : _c(
          "div",
          { staticClass: "row-wrap custom-container" },
          [
            _vm.TcAstralInfo
              ? _c(
                  "div",
                  { staticClass: "params_box" },
                  [
                    _c("div", { staticClass: "personal__btns back-area" }, [
                      _c(
                        "div",
                        {
                          staticClass: "personal__cancel",
                          on: { click: _vm.backToForm }
                        },
                        [_vm._v("返回設定")]
                      )
                    ]),
                    _c("div", { staticClass: "relocation-info" }, [
                      _c("div", { staticClass: "relocation-info__item" }, [
                        _c("span", { staticClass: "relocation-info__label" }, [
                          _vm._v("出生年月日")
                        ]),
                        _c("span", { staticClass: "relocation-info__value" }, [
                          _vm._v(_vm._s(_vm.formattedBirthDateTime))
                        ])
                      ]),
                      _c("div", { staticClass: "relocation-info__item" }, [
                        _c("span", { staticClass: "relocation-info__label" }, [
                          _vm._v("出生地")
                        ]),
                        _c("span", { staticClass: "relocation-info__value" }, [
                          _vm._v(_vm._s(_vm.birthCity))
                        ])
                      ]),
                      _c("div", { staticClass: "relocation-info__item" }, [
                        _c("span", { staticClass: "relocation-info__label" }, [
                          _vm._v("欲前往的城市")
                        ]),
                        _c("span", { staticClass: "relocation-info__value" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.destinationCity) +
                              "\n            "
                          ),
                          _vm.destinationLat && _vm.destinationLng
                            ? _c(
                                "span",
                                { staticClass: "relocation-info__coords" },
                                [
                                  _vm._v(
                                    "\n              （" +
                                      _vm._s(_vm.destinationLat) +
                                      ", " +
                                      _vm._s(_vm.destinationLng) +
                                      "）\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ]),
                    _c("Params", {
                      attrs: {
                        TcAstralInfo: _vm.TcAstralInfo,
                        AstrolabeType: "C2",
                        role: _vm.role,
                        moondayObj: _vm.moondayObj
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.TcAstralInfo
              ? _c("NewAstrolabe", {
                  attrs: {
                    data1: _vm.TcAstralInfo.AstralRadians,
                    data2: null,
                    type: 0,
                    styleArray: _vm.styleArray,
                    role: _vm.role,
                    Ret1: _vm.TcAstralInfo.RetAstralSet,
                    showNowTime: false,
                    format_time: _vm.formattedBirthDateTime,
                    mode: "astrometryMode",
                    nowTimeNowPlaceBtn: false,
                    nowTimeNowPlaceIng: false,
                    nowPlace: _vm.destinationPlaceDisplay,
                    moondayObj: _vm.moondayObj,
                    hiddenuserDesktopInfo: true
                  }
                })
              : _vm._e()
          ],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header custom-container" }, [
      _c("span", [_vm._v("重置盤")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "item__title" }, [
      _vm._v("\n              日光節約時間\n              "),
      _c("img", { attrs: { src: require("@/assets/日光節約icon.svg") } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }